<template>
  <v-row >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800px"
    >
      <template v-slot:activator="{ on, attrs }">
       
       <v-btn 
       v-bind="attrs"
          v-on="on"
          data-cy="add-principal-input"
       @click="principalEdit" 
       >
       <v-icon left>mdi-pencil</v-icon></v-btn>
       
      </template>


      <v-card>
        <v-card-title class="text-h5">
          Principal  - Clave: {{principalData.id}}
        </v-card-title>
        
<v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                

                <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
   
    <v-text-field
           v-model="principal.nombre"
           label="Nombre"
           :counter="2"
           :rules="textRules"
           required
         ></v-text-field>

            <v-text-field
           v-model="principal.apellido"
           label="Apellido"
           :counter="2"
           :rules="textRules"
           required
         ></v-text-field>
   

<!-- <CloudImage :path="principal.linkPhoto" :refresh="refreshImage" /> -->

<!-- <v-file-input
    ref="myfile" @change="handleFileChange"
    label="File input"
    filled
    prepend-icon="mdi-camera"
  ></v-file-input> -->


     <!-- <input type="file" ref="myfile" @change="handleFileChange">  -->

<!-- <v-file-input
            v-if="!fileData.downloadUri"
            v-model="archivo"
            show-size
            chips
            label="Adjuntar archivo"
            prepend-icon="mdi-camera"
            @change="uploadFile"
            ref="file"
            data-cy="file-input"
          ></v-file-input>
          <div v-if="fileData.downloadUri">
            <p>Archivo Agregado</p>
            <span>
              <a :href="server_url + fileData.downloadUri">
                {{ fileData.fileName }}
                <v-icon color="blue">mdi-download</v-icon>
              </a>
              <button @click="removeFile()">
                <v-icon color="red">mdi-delete</v-icon>
              </button>
            </span>
          </div>

<v-file-input
      v-model="file"
      label="Subir archivo"
      filled
      prepend-icon="mdi-camera"
      @change="handleFileChange"
       ref="myfile"
            data-cy="file-input"
    ></v-file-input>


    <button @click="upload">Subir imagen</button> -->

<!-- <progress :value="UploadValue" max="100" id="uploader"> -->

   <!-- <v-progress-linear :value="UploadValue" max="100" id="uploader"></v-progress-linear>

  <input type="file" @change="onFileSelected">

<button @click="onUpload">Subir imagen 2</button>
<img width="320" :src="this.picture"> -->


   
    <v-text-field
           v-model="principal.linkPhoto"
           label="Link_photo"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>

          <v-text-field
           v-model="principal.linkVideo"
           label="LinkVideo"
         ></v-text-field>
   
   
  
   			
    <v-text-field
           v-model="principal.descripcion"
           label="Summary"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>

         <v-col cols="6" md="6">
       <v-row no-gutters>
      <v-col order="first" class="mb-6">
        <PrincipalOpcion 
        class="pa-2"
        outlined
        tile
         :principalData="principal"
         @seleccionarPrincipalOpcion="recibirPrincipalOpcion">     </PrincipalOpcion>

        </v-col>
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row> 
 </v-col>
   
   
    <v-text-field
           v-model="principal.observacion"
           label="Observación"
         ></v-text-field>
   

   
   
   

   
  
   

 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>


      
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrarPrincipal"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="dialog = false"
      >
        Cancelar
      </v-btn>
  
    </v-form> 
            </v-card-text>
               


              </v-col>
              
            </v-row>
          </v-container>
        </v-card-text>


        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn    
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Disagree
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Agree
          </v-btn>
        </v-card-actions>  -->
      </v-card>




    </v-dialog>
  </v-row>
</template>




<script>

import principalService from "@/services/principalService.js";
import PrincipalOpcion from '../principal/PrincipalOpcionDialog.vue';

//import  {storage} from "../../firebase"
//import  {uploadBytes} from "firebase/storage"
//import {ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
//import  CloudImage  from '../CloudImage.vue'

 
export default {

   props: {
    principalData: {
      type: Object, // Tipo de dato correspondiente al objeto del autor
      default: () => ({}) // Valor por defecto, un objeto vacío si no se proporciona
    },

  },
 
 
  data: vm => ({
  //<td v-on:click="guardarPrincipal(principal)">{{principal.name}}</td>
  valid: true,
    dialog:false,
    errors: "",
    showError: false,
    principals: [],
    buscador:'',
     refreshImage: false,
     selectedFile:null,
     UploadValue:0,
     picture:null,
     file: null,


     
      server_url: "",
      valid: false,
      archivo: null,
      fileData: {
        downloadUri: "",
      },
    principal:{

nombre:'',
apellido:'',
linkPhoto:'',
descripcion:'',
observacion:'',
id:'',

          
        },
  
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
  }),
  components:{
      PrincipalOpcion
  },
  mounted() {
    //this.listar();
    // console.log('Código del autor:', this.principalData);

   //  this.principal=this.principalData;
  },
  methods: {

    principalEdit(){
      console.log(this.principalData);
      this.principal=this.principalData;
    },
    listar() {
      principalService
        .listar()
        .then((resposta) => {
          console.log(resposta.data);
          this.principals = resposta.data;
         
        })
        .catch((e) => {
          this.errors = e.response.data.errors;
        });
    }, 
    registrarPrincipal:function(){

            if (this.$refs.form.validate()) {

              let res;
    this.redirect='/principal';
    principalService.update(this.principal).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response);
          //  setTimeout( 
             //   ()=> (this.redirect !=='') ? window.location.href = this.redirect:''
             //   ,2000)
        }).catch((errors) =>{
          //  let desc='';
         //   res = errors.response.data.status;
         //   errors.response.data.errors.map( (e) =>{ desc= desc+' '+e})
           console.log('error');
            console.log(errors);

//console.log(errors.message);
           
        })
        console.log(res);


            }


      //console.log(principal);
            this.$emit('principalEdit',this.principal);
            this.dialog=false;
        },
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.principal={
				nombre:'',
        apellido:'',
				linkPhoto:'',
				descripcion:'',
				observacion:'',
				id:'',
	}
  },
           upload: function() {

            const file2 = this.$refs.myfile.files[0];
      const storageRef = ref(storage, `folder/${file2.name}`);

     // const storageRef = ref(storage, 'folder/myfile.gif');
      uploadBytes(storageRef,this.$refs.myfile.files[0]).then((snapshot)=> {
        console.log("uploaded")
      })
    },
    upload3: function() {
  const file = this.file;

console.log(file);
 /* if (file) {
    const storageRef = ref(storage, `folder/${file.name}`);

    uploadBytes(storageRef, file).then((snapshot) => {
      console.log("Archivo subido correctamente");
      // Aquí podrías hacer algo después de la subida exitosa, si es necesario
    }).catch((error) => {
      console.error("Error al subir el archivo:", error);
    });
  } else {
    console.error("No se ha seleccionado ningún archivo");
  }*/
}
          ,
    async upload2() {
      const file = this.$refs.myfile.files[0];
      const storageRef = ref(storage, `folder/${file.name}`);

      // Sube el archivo a Firebase Storage
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on('state_changed',
        (snapshot) => {
          // Observa el progreso, si es necesario
        },
        (error) => {
          console.error('Error al subir el archivo:', error);
        },
        () => {
          // Subida exitosa, obtén la URL de descarga
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            // Actualiza principal.link_photo con la URL de la imagen
            console.log(downloadURL);
            this.principal.linkPhoto = downloadURL;

            // Activa el refresco del componente CloudImage
            this.refreshImage = !this.refreshImage;
          });
        }
      );
    },
    onFileSelected(event){
        this.selectedFile =event.target.files[0];
    },
    onUpload() {
    const storageRef = firebase.storage().ref(`/folder/${this.selectedFile.name}`);
    const task = storageRef.put(this.selectedFile);

    task.on('state_changed',snapshot=>{
      let percentaje= (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      this.UploadValue=percentaje;
    },error=>{console.log(error.message)},
    ()=>{this.UploadValue=100;
            task.snapshot.ref.getDownloadURL.then((url)=>{
              this.picture=url;
              console.log(this.picture);
            });
    });
    
    },
     handleFileChange(event) {
      const file = this.file;
      if (file) {
        console.log(file.name);
        this.principal.link_photo = 'folder/'+file.name;

        console.log(this.principal.linkPhoto);


       const file2 = this.$refs.myfile.files[0];
      const storageRef = ref(storage, `folder/${file2.name}`);

     // const storageRef = ref(storage, 'folder/myfile.gif');
      uploadBytes(storageRef,this.$refs.myfile.files[0]).then((snapshot)=> {
        console.log("uploaded")
      })



      }






    }



    ,
    uploadFile: function () {
      if (this.archivo) this.submitFile();
      else this.removeFile();
    },
    submitFile() {
      console.log(this.archivo);



      const storageRef = ref(storage, `folder/${this.archivo.name}`);

     // const storageRef = ref(storage, 'folder/myfile.gif');
      uploadBytes(storageRef,this.archivo).then((snapshot)=> {
        console.log("uploaded")
      })



      console.log('submit');

      this.principal.linkPhoto = 'folder/'+this.archivo.name;
    },
    removeFile() {
        this.fileData = { downloadUri: "" };
      
        this.archivo=null;
  
    },
    recibirPrincipalOpcion:function(principalOpcion){

      console.log('En elemento padre Principal');
        console.log(principalOpcion);
     

    }

  
  
  },//fin methos

    watch: {
      date (val) {
        
			
		
       
      },
    },




}
    
  
</script>